'use strict';

import React from 'react';

import { OnSchedUtils } from '../../utils';
import { GetList }      from '../../actions/listActions';

import ListSearch       from './ListSearch/ListSearch';
import ListItem         from './ListItem/ListItem';
import Pagination       from '../Pagination/Pagination'


const List = ({ properties, image, element, event }) => {
  const [searchTerm, setSearch] = React.useState('');
  const [response, setResponse] = React.useState({});
  
  React.useEffect(() => {
    OnSchedUtils.Loading(element, true, true, 'List', { search: element.options.search });
    
    const searchBy = element.options.searchBy ? element.options.searchBy : 'name';

    const getParams = () => {
      let params = { ...element.params };
      params.offset = 0;

      return params;
    }
    
    const delayDebounceFn = setTimeout(() => 
      GetList(element, { [searchBy]: searchTerm, ...getParams() })
        .then(response => {
          setResponse(response);
          const eventType = 'get' + element.type.slice(0,1).toUpperCase() + element.type.slice(1);
          OnSchedUtils.CustomEvents(element.id, eventType, response);

          OnSchedUtils.Loading(element, false);
        }), 2000);

    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm])

  return (
    <>
    { element.options.search && <ListSearch element={element} searchTerm={searchTerm} setSearch={setSearch} /> }

    <table className="List">
      <tbody>
        {response.data && response.data.map((item, idx) => 
          <ListItem 
            key={idx} 
            item={item} 
            properties={properties} 
            image={image} 
            element={element} 
            event={event}
          />
        )}
      </tbody>
    </table>

    <Pagination element={element} response={response} setResponse={setResponse} />
  </>
  )
}

export default List
